export const tableColumns = [
    {
        name: 'ID',
        selector: row => row.id,
        sortable: true,
        center: true,
        maxWidth: '4rem',
        style: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
    },
    {
        name: 'Fee Type',
        selector: row => row.fee_type,
        sortable: true,
        center: true,
        maxWidth: '9rem',
        cell: row => row.fee_type === 'FIXED_SLAB' ? 'Fixed Slab' : (row.fee_type === 'PERCENTAGE' ? 'Percentage' : '-'),
        style: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
    },
    {
        name: 'Default %',
        selector: row => row.default_percentage,
        sortable: true,
        center: true,
        maxWidth: '7rem',
        cell: row => row.default_percentage != null ? `${row.default_percentage}%` : '-',
        style: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
    },
    {
        name: 'Previous fee amount',
        selector: row => row.previous_fee_amount,
        sortable: true,
        center: true,
        maxWidth: '9.375rem',
        style: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
    },
    {
        name: 'New fee amount',
        selector: row => row.convenience_fee_amount,
        sortable: true,
        center: true,
        maxWidth: '9.375rem',
        style: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
    },
    {
        name: 'Minimum transaction amount',
        selector: row => row.previous_min_amount,
        sortable: true,
        center: true,
        maxWidth: '9.375rem',
        style: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
    },
    {
        name: 'Annual fee increment',
        selector: row => row.convenience_increment,
        sortable: true,
        center: true,
        maxWidth: '9.375rem',
        style: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
    },
    {
        name: 'Modified by',
        selector: row => row.modified_by,
        sortable: true,
        center: true,
        maxWidth: '9.5rem',
        style: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
    },
    {
        name: 'Modified date',
        selector: row => row.modified_date,
        sortable: true,
        center: true,
        maxWidth: '9.5rem',
        style: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
    }
];
